// N0 Name	Date
// 1	Charlotte	4 / 3 / 2016
// 2	Sasha Banks	7 / 25 / 2016
// 3	Charlotte	8 / 21 / 2016
// 4	Sasha Banks	10 / 3 / 2016
// 5	Charlotte Flair	10 / 30 / 2016
// 6	Sasha Banks	11 / 28 / 2016
// 7	Charlotte Flair	12 / 18 / 2016
// 8	Bayley	2 / 13 / 2017
// 9	Alexa Bliss	4 / 30 / 2017
// 10	Sasha Banks	8 / 20 / 2017
// 11	Alexa Bliss	8 / 28 / 2017
// 12	Nia Jax	4 / 8 / 2018
// 13	Alexa Bliss	6 / 17 / 2018
// 14	Ronda Rousey	8 / 19 / 2018
// 15	Becky Lynch	4 / 8 / 2019
// 16	Asuka	5 / 10 / 2020
// 17	Sasha Banks	7 / 27 / 2020
// 18	Asuka	8 / 23 / 2020
// 19	Rhea Ripley	4 / 11 / 2021
// 20	Charlotte Flair	7 / 18 / 2021
// 21	Nikki A.S.H.	7 / 19 / 2021
// 22	Charlotte Flair	8 / 21 / 2021
// 23	Becky Lynch	10 / 22 / 2021
// 24	Bianca Belair	4 / 2 / 2022 DONE
// 25	Asuka	5 / 27 / 2023 DONE
// 26	Bianca Belair	8 / 5 / 2023 DONE
// 27	IYO SKY	8 / 5 / 2023 DONE
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _default = [
    {
        id: "wwe-womens-00",
        wrestlerIds: [
            "iyo-sky"
        ],
        championshipId: "womens-championship",
        startDate: new Date("Aug 05, 2023")
    },
    {
        id: "wwe-womens-01b",
        wrestlerIds: [
            "bianca-belair"
        ],
        championshipId: "womens-championship",
        startDate: new Date("Aug 05, 2023"),
        endDate: new Date("Aug 05, 2023")
    },
    {
        id: "wwe-womens-01",
        wrestlerIds: [
            "asuka"
        ],
        championshipId: "womens-championship",
        startDate: new Date("May 27, 2023"),
        endDate: new Date("Aug 05, 2023")
    },
    {
        id: "wwe-womens-02",
        wrestlerIds: [
            "bianca-belair"
        ],
        championshipId: "womens-championship",
        startDate: new Date("Apr 2, 2022"),
        endDate: new Date("May 27, 2023")
    },
    {
        id: "wwe-womens-03",
        wrestlerIds: [
            "becky-lynch"
        ],
        championshipId: "womens-championship",
        startDate: new Date("Oct 22, 2021"),
        endDate: new Date("Apr 2, 2022")
    },
    {
        id: "wwe-womens-04",
        wrestlerIds: [
            "charlotte-flair"
        ],
        championshipId: "womens-championship",
        startDate: new Date("Dec 30, 2020"),
        endDate: new Date("Oct 22, 2021")
    },
    {
        id: "wwe-womens-05",
        wrestlerIds: [
            "asuka"
        ],
        championshipId: "womens-championship",
        startDate: new Date("Apr 5, 2020"),
        endDate: new Date("Dec 30, 2020")
    },
    {
        id: "wwe-womens-06",
        wrestlerIds: [
            "becky-lynch"
        ],
        championshipId: "womens-championship",
        startDate: new Date("Aug 11, 2019"),
        endDate: new Date("Apr 5, 2020")
    },
    {
        id: "wwe-womens-07",
        wrestlerIds: [
            "charlotte-flair"
        ],
        championshipId: "womens-championship",
        startDate: new Date("Apr 7, 2019"),
        endDate: new Date("Aug 11, 2019")
    },
    {
        id: "wwe-womens-08",
        wrestlerIds: [
            "becky-lynch"
        ],
        championshipId: "womens-championship",
        startDate: new Date("Dec 16, 2018"),
        endDate: new Date("Apr 7, 2019")
    },
    {
        id: "wwe-womens-09",
        wrestlerIds: [
            "ronda-rousey"
        ],
        championshipId: "womens-championship",
        startDate: new Date("Aug 19, 2018"),
        endDate: new Date("Dec 16, 2018")
    },
    {
        id: "wwe-womens-10",
        wrestlerIds: [
            "alexa-bliss"
        ],
        championshipId: "womens-championship",
        startDate: new Date("Jun 17, 2018"),
        endDate: new Date("Aug 19, 2018")
    },
    {
        id: "wwe-womens-11",
        wrestlerIds: [
            "nia-jax"
        ],
        championshipId: "womens-championship",
        startDate: new Date("Apr 8, 2018"),
        endDate: new Date("Jun 17, 2018")
    },
    {
        id: "wwe-womens-12",
        wrestlerIds: [
            "alexa-bliss"
        ],
        championshipId: "womens-championship",
        startDate: new Date("Aug 28, 2017"),
        endDate: new Date("Apr 8, 2018")
    },
    {
        id: "wwe-womens-13",
        wrestlerIds: [
            "sasha-banks"
        ],
        championshipId: "womens-championship",
        startDate: new Date("Aug 20, 2017"),
        endDate: new Date("Aug 28, 2017")
    },
    {
        id: "wwe-womens-14",
        wrestlerIds: [
            "alexa-bliss"
        ],
        championshipId: "womens-championship",
        startDate: new Date("Apr 30, 2017"),
        endDate: new Date("Aug 20, 2017")
    },
    {
        id: "wwe-womens-15",
        wrestlerIds: [
            "bayley"
        ],
        championshipId: "womens-championship",
        startDate: new Date("Feb 13, 2017"),
        endDate: new Date("Apr 30, 2017")
    },
    {
        id: "wwe-womens-16",
        wrestlerIds: [
            "charlotte-flair"
        ],
        championshipId: "womens-championship",
        startDate: new Date("Dec 18, 2016"),
        endDate: new Date("Feb 13, 2017")
    },
    {
        id: "wwe-womens-17",
        wrestlerIds: [
            "sasha-banks"
        ],
        championshipId: "womens-championship",
        startDate: new Date("Nov 28, 2016"),
        endDate: new Date("Dec 18, 2016")
    },
    {
        id: "wwe-womens-18",
        wrestlerIds: [
            "charlotte-flair"
        ],
        championshipId: "womens-championship",
        startDate: new Date("Oct 30, 2016"),
        endDate: new Date("Nov 28, 2016")
    },
    {
        id: "wwe-womens-19",
        wrestlerIds: [
            "sasha-banks"
        ],
        championshipId: "womens-championship",
        startDate: new Date("Oct 3, 2016"),
        endDate: new Date("Oct 30, 2016")
    },
    {
        id: "wwe-womens-20",
        wrestlerIds: [
            "charlotte-flair"
        ],
        championshipId: "womens-championship",
        startDate: new Date("Jul 25, 2016"),
        endDate: new Date("Oct 3, 2016")
    },
    {
        id: "wwe-womens-21",
        wrestlerIds: [
            "sasha-banks"
        ],
        championshipId: "womens-championship",
        startDate: new Date("Apr 3, 2016"),
        endDate: new Date("Jul 25, 2016")
    },
    {
        id: "wwe-womens-22",
        wrestlerIds: [
            "charlotte-flair"
        ],
        championshipId: "womens-championship",
        startDate: new Date("Apr 3, 2016"),
        endDate: new Date("Apr 3, 2016")
    }
];
